import { takeLatest, put, call } from 'redux-saga/effects';
import * as dashboardAction from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';

export function* getDashboardDataValues(action) {
    let requestUrl = `${CORE_API}/dashboard/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(dashboardAction.getDashboardDataSuccess(listResult.data));
    } catch (err) {

        yield put(dashboardAction.getDashboardDataFailure(err))
    }
}
export function* getDashboardData() {
    yield takeLatest(dashboardAction.GET_DASHBOARD_DATA, getDashboardDataValues);
}

export function* checkDashboard(action) {
    let requestUrl = `${CORE_API}/dashboard/fetch/data`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(dashboardAction.getDashboardDataSuccess(listResult.data));
    } catch (err) {

        yield put(dashboardAction.getDashboardDataSuccess(err.response))
    }
}
export function* checkDashboardData() {
    yield takeLatest(dashboardAction.CHECK_DASHBOARD_DATA, checkDashboard);
}

export function* getCaseCountByState(action) {
    let requestUrl = `${CORE_API}/dashboard/getCaseCountAvgScore/${action.data.corporateId}/counterpartyType/${action.data.counterpartyType}`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(dashboardAction.getCaseCountByStateSuccess(listResult.data));
    } catch (err) {
        yield put(dashboardAction.getCaseCountByStateFailure(err.response))
    }
}
export function* caseCountByState() {
    yield takeLatest(dashboardAction.GET_CASE_COUNT_BY_STATE, getCaseCountByState);
}